import { getRoot, types } from 'mobx-state-tree'
import { RootModel } from '@shared/data-access'
import { ContentObject } from '../typeCustom'

export const MODEL_NAME = 'Product'

export const Model = RootModel.named(MODEL_NAME)
  .props({
    id: types.identifier,
    productCode: types.string,
    productMeta: types.maybeNull(ContentObject),
  })
  .volatile((self) => ({
    _store: getRoot(self)[`${MODEL_NAME}Store`],
  }))
